import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { CircleHelp } from "lucide-react";

const CashProcessHelp = () => {
  const content = <Popover id="cash-process-help" className="cash-process-popover">
    <Popover.Header as="h3">Cash workflow and responsibilities</Popover.Header>
    <Popover.Body>
      <div className="cash-help-flow">
        <div><span>1</span><p><strong>Opening cash</strong><small>Employee counts denominations and records the shift opening balance.</small></p></div>
        <div><span>2</span><p><strong>Closing cash</strong><small>Count closing cash. Counter expenses and POS UPI sales are prefilled but must be confirmed.</small></p></div>
        <div><span>3</span><p><strong>Reconcile</strong><small>Compare expected versus actual Cash and UPI. Explain any difference.</small></p></div>
        <div><span>4</span><p><strong>Finalize or approve</strong><small>Balanced shifts finalize directly. Large discrepancies require management approval.</small></p></div>
        <div><span>5</span><p><strong>Employee retains cash</strong><small>In Cash Management Analytics, record the amount kept and expected weekly handover date.</small></p></div>
        <div><span>6</span><p><strong>Collect and close</strong><small>Management records partial or full collections until the outstanding balance becomes zero.</small></p></div>
      </div>
      <div className="cash-help-ownership"><strong>Cash Float</strong><span>Daily entry and reconciliation</span><strong>Cash Management Analytics</strong><span>Approvals, variance review, retained cash and collections</span></div>
    </Popover.Body>
  </Popover>;

  return <OverlayTrigger trigger={["hover", "focus", "click"]} placement="bottom" overlay={content} rootClose>
    <button type="button" className="cash-process-help" aria-label="Show Cash Float workflow"><CircleHelp size={20}/><span>Process guide</span></button>
  </OverlayTrigger>;
};

export default CashProcessHelp;
